import React, { Component } from "react";
import axios from "axios";
import { logger } from "../../utils/common";
import Wizard from "./ReadOnlyWizard";
import config from "../../config.json";

export class FormSelection extends Component {
  constructor() {
    super();
    const claimsList = [];
    this.wizardComp = <div />;
    this.state = { loadedFormData: {}, errorMsg: null };
    this.id = "";
    if (this.getUrlParameter("FID")) {
      this.FID = this.getUrlParameter("FID");
      console.log("ID:", this.FID);
      const { hostname } = window.location;
      let url = "";
      for (const host in config.hosts) {
        if (hostname === config.hosts[host].hostname) {
          logger([`Running on ${host} environment.`]);
          url = config.hosts[host].getFormEndpoint;
          logger(["setting Get Form API url to ", url]);
        }
      }
      if (!url) {
        // set default url if not set
        console.warn("No valid Get Form API endpoint found in config. Setting to default.");
        url = config.hosts.default.getFormEndpoint;
      }
      console.log("URL", url);

      axios
        .post(url, {
          FormGUID: this.FID
        })
        .then((response) => {
          logger(["response: ", response]);
          if (response.data.FormData.length > 1) {
            this.setState({ ...this.state, errorMsg: "Duplicate Form GUID." });
            return;
          }
          let formData;
          const fromDate = { createdDate: response.data.FormData[0].Created };

          if (response.data.FormData[0].Form_x0020_Data) {
            // QA mapping
            formData = JSON.parse(response.data.FormData[0].Form_x0020_Data);
            formData = { ...formData, ...fromDate };
          } else if (response.data.FormData[0].wa5v) {
            // PROD mapping
            formData = JSON.parse(response.data.FormData[0].wa5v);
            formData = { ...formData, ...fromDate };
          }

          console.log("formData", formData);
          this.setState({ ...this.state, formData });
        })
        .catch((error) => {
          console.log("err", error);
          this.setState({ ...this.state, errorMsg: "Form not found." });
        });
    }

    this.state = {};
  }

  getUrlParameter(_name) {
    const name = _name.replace(/\[/, "[").replace(/\]/, "]");
const regex = new RegExp(`[?&]${name}=([^&#]*)`);
const results = regex.exec(window.location.search);
return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  render() {
    const { errorMsg, formData } = this.state;
    const errorComponent = (
      <div
        className="alert alert-danger"
        role="alert"
        style={{ width: "60%", marginLeft: "auto", marginRight: "auto" }}
      >
        <h4 className="alert-heading">Error</h4>
        <p>{errorMsg}</p>
      </div>
    );
    return (
      <div style={{ minHeight: "400px" }}>
        {!errorMsg && !formData ? "Loading..." : null}
        {errorMsg ? errorComponent : null}
        {formData ? <Wizard selectFormData={formData} formData={formData} readOnly /> : null}
      </div>
    );
  }
}

export default FormSelection;
